import {
  getObject,
  getOptionalObject,
  getString,
} from "@surya-digital/leo-ts-types";
import { SurveyLocalizedText, SurveyLocalizedTextDTO } from "../assets/surveyLocalizedText";

export interface OpenEndedFieldResponseV1DTO {
  optionFieldTitle?: SurveyLocalizedTextDTO | null;
  answer: string;
}

export class OpenEndedFieldResponseV1 {
  readonly isOpenEndedFieldResponseV1OpenEndedFieldResponseV1: boolean = true;

  readonly optionFieldTitle: SurveyLocalizedText | null;
  readonly answer: string;


  constructor(
  optionFieldTitle: SurveyLocalizedText | null = null, 
  answer: string
  ) {
    this.optionFieldTitle = optionFieldTitle;
    OpenEndedFieldResponseV1.validateAnswer(answer);
    this.answer = answer;
  }

  static fromDTO(dto: OpenEndedFieldResponseV1DTO): OpenEndedFieldResponseV1 {
    let optionFieldTitle = getOptionalObject(dto, "optionFieldTitle");
    if(optionFieldTitle !== undefined && optionFieldTitle !== null) {
      optionFieldTitle = SurveyLocalizedText.fromDTO(getObject(dto, "optionFieldTitle", InvalidOpenEndedFieldResponseV1OptionFieldTitleError));
    }
    const answer = getString(dto, "answer", InvalidOpenEndedFieldResponseV1AnswerError);
    return new OpenEndedFieldResponseV1(
      optionFieldTitle,
      answer
    );
  }

  toDTO(): OpenEndedFieldResponseV1DTO {
    const dto: OpenEndedFieldResponseV1DTO = {
        answer: this.answer
    };
    if (this.optionFieldTitle !== undefined && this.optionFieldTitle !== null){
      dto.optionFieldTitle = this.optionFieldTitle.toDTO();
    }
    return dto;
  }
  private static validateAnswer = (answer: string): void => {
    if(answer.trim().length === 0) {
      throw new InvalidOpenEndedFieldResponseV1AnswerNonEmptyError(
        `Attribute answer cannot be an empty string.`
      );
    }
  }
  
}

OpenEndedFieldResponseV1.prototype.toString = function toString(): string {
  return `OpenEndedFieldResponseV1(optionFieldTitle='${this.optionFieldTitle}',answer='${this.answer}')`;
};

export class InvalidOpenEndedFieldResponseV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOpenEndedFieldResponseV1Error";
  }
}
export class InvalidOpenEndedFieldResponseV1OptionFieldTitleError extends InvalidOpenEndedFieldResponseV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOpenEndedFieldResponseV1OptionFieldTitleError";
  }
}

export class InvalidOpenEndedFieldResponseV1AnswerError extends InvalidOpenEndedFieldResponseV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOpenEndedFieldResponseV1AnswerError";
  }
}

export class InvalidOpenEndedFieldResponseV1AnswerNonEmptyError extends InvalidOpenEndedFieldResponseV1AnswerError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOpenEndedFieldResponseV1AnswerNonEmptyError";
  }
}
